import React, { useState, useEffect } from "react";
import Table from "../components/Table/Table";
import { Tooltip } from "react-tooltip";
import { FaInfoCircle } from "react-icons/fa";
import "react-tooltip/dist/react-tooltip.css"; // Import the CSS for react-tooltip
import QualityLossBarChart from "../components/QualityLoss/QualityLoss_Graph";



const QualityLoss = () => {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);

  useEffect(() => {
    setHeaders([
      {
        dbParam: "supplier_name",
        displayName: "Supplier Name",
      },
      {
        dbParam: "module_wattage",
        displayName: "Module Wattage",
      },
      {
        dbParam: "quality_loss",
        displayName: (
          <>
            Quality Loss{" "}
            <FaInfoCircle
            className="mx-2"
              data-tooltip-id="qualityLossTooltip"
              style={{ cursor: "pointer", color: "white" }}
            />
            <Tooltip id="qualityLossTooltip" place="top" effect="solid">
              (sum(Pmax)/no. of modules) - total watt power
            </Tooltip>
          </>
        ),
      },
    ]);
    setData([
      {
        supplier_name: "Waree",
        module_wattage: 335,
        quality_loss: "2.7%",
      },
      {
        supplier_name: "Waree",
        module_wattage: 445,
        quality_loss: "2.9%",
      },
      {
        supplier_name: "Waree",
        module_wattage: 350,
        quality_loss: "2.2%",
      },
      {
        supplier_name: "Waree",
        module_wattage: 335,
        quality_loss: "3.2%",
      },
    ]);
  }, []);

  return (
    <div className="mt-5 space-y-10">
      <div className="w-full text-center border-b-2 pb-2">
        <div className="font-semibold" style={{ color: "#808080" }}>
          Quality Loss ( From approved PDI )
        </div>
      </div>
      <Table tableHeaders={headers} tableData={data} />
      <QualityLossBarChart data={data} />
    </div>
  );
};

export default QualityLoss;
